import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=13f29614&scoped=true"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=13f29614&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f29614",
  null
  
)

export default component.exports